import React from "react";
import styles from "./style.module.scss";
import cx from "classnames";
import { Col, Row, Container } from "reactstrap";

const Heading = (props) => {
  const { headingLevel, className, sticky, bordered, yellowBg, label, ...rest } = props;
  const HeadingTag = `${headingLevel}`;

  const WrapperTag = sticky ? Container : "div";

  return (
    <>
      <div className={cx(
        {
          [styles.heading]: yellowBg,
          [styles.heading_bordered]: bordered,
          [styles.heading_stiky]: sticky,
          "sticky-top": sticky
        })} >
        <WrapperTag className={cx(
          {
            [className]: className,
          }
        )} >
          <Row>
            <Col xs="12" sm={true}>
              <HeadingTag {...rest} >
                {label}
              </HeadingTag>
            </Col>
            {props.children}
          </Row>
        </WrapperTag>
      </div >
      <div className={cx(
        {
          "mb-4": bordered,
          "mb-2": !bordered
        }
      )}></div>
    </>
  );
}

export default Heading;